import { PositionHeight, WebLogoPropsDefault } from './web-logo';
// Data structures for V-Domain regions of antibodies
export var VdRegionType;
(function (VdRegionType) {
    VdRegionType["Unknown"] = "unknown";
    VdRegionType["FR"] = "framework";
    VdRegionType["CDR"] = "cdr";
})(VdRegionType || (VdRegionType = {}));
export const VdRegionsPropsDefault = new class {
    constructor() {
        this.regionTypes = [VdRegionType.CDR];
        this.chains = ['Heavy', 'Light'];
        //sequenceColumnNamePostfix: string = 'chain sequence';
        this.skipEmptyPositions = false;
        this.fitWidth = false;
        this.positionWidth = 16;
        this.positionHeight = PositionHeight.Entropy;
        this.filterSource = WebLogoPropsDefault.filterSource;
    }
}();
//# sourceMappingURL=vd-regions.js.map